import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class CardStackController extends Controller {
  @service
  rpc

  @service("ember-store")
  store

  @belongsTo("model", "course")
  course

  @computed("model.id", "model.attributes.version")
  get documentVersions() {
    let modelType = get(this, "model.type")
    let id = get(this, "model.id")
    let promise = get(this, "rpc")["GET_DOCUMENT_VERSIONS_FOR"](modelType, id)
    return ObjectPromiseProxy.create({
      promise: promise,
    })
  }
}
